import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-191" data-mp="3kqw54mwtl6h6">
      <div className="mx-auto max-w-5xl" data-id="element-192" data-mp="3fz5mzurn5ef7">
        <span className="block text-center text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-193" data-mp="3fxuly2pkykrs">
          Zaufanie nauczycieli
        </span>
        <h2 className="mt-5 text-center font-display text-[1.75rem] font-black leading-tight tracking-tight text-ink sm:text-[2.4rem]" data-id="element-194" data-mp="36zimrcaneenq">
          Co mówią polscy pedagodzy
        </h2>

        <div className="mx-auto mt-10 grid max-w-3xl gap-5 sm:grid-cols-2" data-id="element-195" data-mp="2x0jngkbrvvde">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col rounded-2xl bg-sand p-6" data-id="element-196" data-mp="2s2i561m6802z">
              <div className="flex gap-0.5" aria-label="5 gwiazdek na 5" data-id="element-197" data-mp="v8wuid8blqea">
                {Array.from({
              length: 5
            }).map((_, starIndex) => <StarIcon key={starIndex} className="h-3.5 w-3.5 fill-amber-500 text-amber-500" aria-hidden="true" data-id="element-198" data-mp="h67zg4hknoad" data-mpi={starIndex} />)}
              </div>
              <blockquote className="mt-4 flex-1 font-display text-sm italic leading-relaxed text-ink/85" data-id="element-199" data-mp="78tub113mlxd">
                &bdquo;{item.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-6" data-id="element-200" data-mp="zvwfyskof267">
                <p className="text-xs font-bold text-ink" data-id="element-201" data-mp="zx7thk3xboai">{item.name}</p>
                <p className="text-xs text-ink/50" data-id="element-202" data-mp="14uhgkt3ubnv6">{item.location}</p>
              </figcaption>
            </figure>)}
        </div>

        <p className="mt-8 text-center text-[11px] text-ink/40" data-id="element-203" data-mp="q4jv4kxapc9o">
          Opinie mają charakter poglądowy.
        </p>
      </div>
    </section>;
}